import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';
import { setUserSetting } from '../../actions/Auth';

import { APIremoveUserSettingValue } from '../../api/User';

import { getMatchingSearches } from '../../helpers/Search';
import { addFlashMessage } from '../../helpers/FlashMessages';

const PinnedSearchesIcons = ({
  openModal,
  selectedFilters,
  type,
  profile,
  openConfirmationModal,
  handleSetUserSettings,
}) => {
  const intl = useIntl();

  const matchingSearches = getMatchingSearches(selectedFilters, type);

  const handleRemove = () => {
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this pinned search?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this pinned search?' }),
      confirmText: intl.formatMessage({ defaultMessage: 'Delete' }),
      onConfirm: async () => {
        const response = await APIremoveUserSettingValue(profile.uuid, 'pinned_searches', matchingSearches[0].uuid);
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'Deleted pinned search' }),
        });
        handleSetUserSettings({ pinned_searches: response.data });
        return Promise.resolve();
      },
    };

    openConfirmationModal(modalParams);
  };

  if (matchingSearches.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        color="link"
        size="sm"
        id="EditPinnedSearchButton"
        className="button-icon"
        onClick={() => openModal({
          mode: 'manage',
          type,
          pinnedSearch: matchingSearches[0],
          selectedFilters,
          className: 'pin-search-modal',
        })}
      >
        <i className="far fa-pencil" />
      </Button>
      <UncontrolledTooltip fade={false} placement="top" target="EditPinnedSearchButton">
        {intl.formatMessage({ defaultMessage: 'Edit pinned search' })}
      </UncontrolledTooltip>
      <Button
        color="link"
        size="sm"
        onClick={handleRemove}
        id="RemovePinnedSearchButton"
        className="button-icon"
      >
        <i className="far fa-trash" />
      </Button>
      <UncontrolledTooltip fade={false} placement="top" target="RemovePinnedSearchButton">
        {intl.formatMessage({ defaultMessage: 'Delete pinned search' })}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

const mapDispatchToProps = dispatch => ({
  openModal: (params) => {
    dispatch(showModal('PinSearchModal', params));
  },
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  handleSetUserSettings: (settings) => {
    dispatch(setUserSetting(settings));
  },
});

PinnedSearchesIcons.propTypes = {
  profile: PropTypes.object,
  openModal: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  handleSetUserSettings: PropTypes.func.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

PinnedSearchesIcons.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(PinnedSearchesIcons);
